import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import NavView from './views/public/NavView.vue'
import BottomView from './views/public/BottomView.vue'
import { onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const checkAndRedirect = ()=> {
      const mobileWidth = 768;
      if (window.innerWidth <= mobileWidth) {
        const currentDomain = window.location.hostname;
        if (currentDomain === 'www.rekeymed.com' || currentDomain === 'rekeymed.com') {
          window.location.href = 'https://m.rekeymed.com' + window.location.pathname + window.location.search;
        }
      }
    }
    onMounted(()=>{
      checkAndRedirect()
    })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavView),
    _createVNode(_component_router_view),
    _createVNode(BottomView)
  ]))
}
}

})